import { render, staticRenderFns } from "./WordCloud.vue?vue&type=template&id=08725744&scoped=true&"
import script from "./WordCloud.vue?vue&type=script&lang=js&"
export * from "./WordCloud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08725744",
  null
  
)

export default component.exports